import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=7ba8a7ac&scoped=true&lang=pug&"
import script from "./Impressum.vue?vue&type=script&lang=ts&"
export * from "./Impressum.vue?vue&type=script&lang=ts&"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=7ba8a7ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8a7ac",
  null
  
)

export default component.exports